// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"50269891","399":"cdb69196","404":"31d6cfe0","721":"68fc3964","780":"3cbc6abb","787":"829cbf05"}[chunkId] + ".chunk.css";
};